module.exports = __webpack_public_path__ + "img/eye-young-complete-1-muscle-fibres.5a2a67cf.jpg";